import React from "react";
import { Dialog, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material";
import { ReportProblemOutlined } from "@mui/icons-material";

// Reusable modal for irreversible actions (props-driven).
const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title = "Questa operazione è irreversibile.",
  subtitle = "Vuoi procedere?",
  message = "Eliminando il tuo account, tutti i dati associati, incluse campagne attive, saldo residuo e storico dei pagamenti saranno cancellati in modo permanente.",
  cancelText = "ANNULLA",
  confirmText = "CONFERMA",
  confirmColor = "#e00036",
  cancelColor = "#0b3d87",
  icon = <ReportProblemOutlined sx={{ color: "white", fontSize: 50 }} />,
  hideCancelButton = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          overflow: "hidden",
        },
      }}
    >
      <DialogContent
        sx={{
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          p: 3,
        }}
      >
        <Box
          sx={{
            width: 84,
            height: 84,
            backgroundColor: confirmColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            marginBottom: 2.5,
          }}
        >
          {icon}
        </Box>

        <Typography variant="h5" sx={{ fontFamily: "Rubik", fontWeight: "bold", color: "#0b3d87" }}>
          {title}
        </Typography>

        <Typography variant="h5" sx={{ fontFamily: "Rubik", fontWeight: "bold", color: "#0b3d87", marginBottom: 1 }}>
          {subtitle}
        </Typography>

        <Typography sx={{ fontFamily: "Rubik", color: "#0b3d87", fontSize: "14px", maxWidth: "400px", marginBottom: 2 }}>
          {message}
        </Typography>

        <DialogActions sx={{ display: "flex", gap: 2, justifyContent: "center", width: "100%", mt: 1 }}>
          {!hideCancelButton && (
            <Button
              onClick={onClose}
              sx={{
                fontFamily: "Rubik",
                backgroundColor: cancelColor,
                color: "white",
                fontWeight: "bold",
                padding: "8px 20px",
                borderRadius: "20px",
                "&:hover": { backgroundColor: "#092b6a" },
              }}
            >
              {cancelText}
            </Button>
          )}

          <Button
            onClick={onConfirm}
            sx={{
              fontFamily: "Rubik",
              backgroundColor: confirmColor,
              color: "white",
              fontWeight: "bold",
              padding: "8px 20px",
              borderRadius: "20px",
              "&:hover": { backgroundColor: confirmColor ? confirmColor : "#b0002e" },
            }}
          >
            {confirmText}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationModal;